import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UtilService } from '../../providers/util.service';


@Component({
  selector: 'app-fale-com-agente',
  templateUrl: './fale-com-agente.component.html',
  styleUrls: ['./fale-com-agente.component.scss']
})
export class FaleComAgenteComponent implements OnInit {

  assunto = '';
  isLoading = false;
  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
  }

  postContato(form: FormGroup) {

    const values = form.value;

    this.isLoading = true;

    this.util.postContato(values)
    .subscribe(
      data => { 
        this.util.callAlert('Ok', 'Seu contato foi enviado com sucesso!', 'success');
        
        setTimeout(() => {
          this.isLoading = false; 
        }, 2000);
        
        form.reset(); 
      },
      err => { 
        this.util.callAlert('Ops', 'Ocorreu um erro ao enviar sua mensagem!', 'error');
        setTimeout(() => {
          this.isLoading = false; 
        }, 2000);
      }
    );

  }

}
